// useAddSupportNote (issue #419) — POST /chats/support/:chatId/internal-note.

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addSupportNote, SupportInboxScope } from './api';
import { chatKeys } from './keys';

import type { ChatMessage } from 'src/models/chat';

interface Args {
  chatId: number;
  content: string;
}

export function useAddSupportNote(scope: SupportInboxScope = 'legacy') {
  const queryClient = useQueryClient();
  return useMutation<ChatMessage, unknown, Args>(
    ({ chatId, content }) => addSupportNote(chatId, { content }, scope),
    {
      onSuccess: (_message, { chatId }) => {
        queryClient.invalidateQueries(chatKeys.chatMessages(chatId));
      },
    }
  );
}
